import { useState, useEffect } from "react";
import { Grid, RenderEnderecoPrint } from "../../../../components";
import { SessionService } from "../../../../services";
import { value } from "../../../../helpers";
import { format } from "date-fns";
import {
  formatCelular,
  formatCpf,
  formatPrice,
  formatCnpj,
  formatTelefone,
} from "../../../../utils";
import "../../../orcamentos/addOrcamento/components/mainPrintLayout.style.css";

const MainPrintLayout = ({ data }) => {
  const sessionService = new SessionService();
  const [empresa, setEmpresa] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(0);
  const aspectLogo = (event) => {
    setAspectRatio(event.target.naturalWidth / event.target.naturalHeight);
  };

  useEffect(() => {
    const data = sessionService.getEmpresa();
    setEmpresa(data);
  }, []);

  return (
    empresa &&
    data && (
      <>
        <Grid
          item
          md={12}
          xs={12}
          className="d-flex justify-content-between align-items-center"
        >
          <div className="d-flex justify-content-between align-items-center">
            {empresa?.imagemLogo ? (
              <img
                className="me-3"
                src={empresa.imagemLogo}
                alt="logo da empresa"
                onLoad={aspectLogo}
                width={100}
                height={aspectRatio <= 1.5 ? 100 : 20}
              />
            ) : null}
            <div>
              <b>{empresa.fantasia}</b>
              <br />
              CNPJ - {formatCnpj(empresa.cnpj)}
              <br />
              {`${empresa.enderecoLogradouro} - ${empresa.enderecoLogradouroNumero} - ${empresa.enderecoBairro} - ${empresa.enderecoCidade}-${empresa.enderecoUF}`}
            </div>
          </div>
          <div className="me-5">
            {empresa.telefone?.length > 0
              ? formatTelefone(empresa.telefone)
              : formatCelular(empresa.celular)}
            <br />
            {empresa.email}
            <br />
            {data?.vendedor ? <b>Vendedor - {data.vendedor}</b> : ""}
          </div>
        </Grid>
        <Grid item md={12} xs={12} className="mt-4">
          <table className="table">
            <thead style={{ background: "#E7E5E6" }}>
              <tr>
                <th className="d-flex justify-content-between align-items-center">
                  <span className="fs-5 fw-bold">{`PEDIDO Nº ${data.numeroDocumento}`}</span>
                  <span className="fw-bold">
                    {format(
                      new Date(Date.parse(data.dataEmissao)),
                      "dd/MM/yyyy HH:MM"
                    )}
                  </span>
                </th>
              </tr>
            </thead>
          </table>
        </Grid>
        <Grid
          item
          md={12}
          xs={12}
          className="d-flex justify-content-between align-items-center mt-2"
        ></Grid>
        <Grid item md={12} xs={12} className="mt-4 orcamento-print-fs-07">
          <table className="table">
            <thead style={{ background: "#E7E5E6" }}>
              <tr>
                <th className="p-0">DADOS CLIENTE</th>
              </tr>
            </thead>
          </table>
        </Grid>
        <div className="flex-print-container orcamento-print-fs-07">
          <div className="container-item-50">
            <div>
              <div>
                <b className="me-2 fs-7">Cliente:</b>
                <span className="fs-7 fw-normal">
                  {data.cliente?.nomeRazaoSocial}
                </span>
              </div>
              <div>
                <b className="me-2 fs-7">Endereço:</b>
                <span className="fs-7 fw-normal">
                  <RenderEnderecoPrint
                    enderecoCliente={data?.enderecoCliente}
                  />
                </span>
              </div>
              <div>
                <b className="me-2 fs-7">Telefone:</b>
                <span className="fs-7 fw-normal">
                  {`${formatTelefone(data.cliente?.telefone) ?? ""} ${
                    data.cliente?.celular
                      ? " | " + formatCelular(data.cliente?.celular)
                      : ""
                  }`}
                </span>
              </div>
            </div>
          </div>
          <div className="container-item-40">
            <div>
              <div>
                <b className="me-2 fs-7">CNPJ/CPF:</b>
                <span className="fs-7 fw-normal">
                  {data.cliente?.naturezaSocial === "fisica"
                    ? formatCpf(data.cliente?.cnpjCpf)
                    : formatCnpj(data.cliente?.cnpjCpf)}
                </span>
              </div>
              <div>
                <b className="me-2 fs-7">Estado:</b>
                <span className="fs-7 fw-normal">
                  {data.estadoCliente ?? ""}
                </span>
              </div>
              <div>
                <b className="me-2 fs-7">E-mail:</b>
                <span className="fs-7 fw-normal">{data.cliente?.email}</span>
              </div>
            </div>
          </div>
        </div>
        <Grid item md={12} xs={12} className="mt-4 orcamento-print-fs-07">
          <table className="table">
            <thead style={{ background: "#E7E5E6" }}>
              <tr>
                <th className="p-0">PRODUTOS</th>
              </tr>
            </thead>
          </table>
        </Grid>
        <Grid item md={12} xs={12}>
          <table className="table table-striped">
            <thead>
              <tr className="orcamento-print-fs-07">
                <th>ITEM</th>
                <th style={{ width: "40%" }}>DESCRIÇÃO</th>
                <th className="text-end">UND.</th>
                <th className="text-center">QTD.</th>
                <th style={{ width: "12%" }} className="text-end">
                  VR. UNIT.
                </th>
                <th className="text-end">SUBTOTAL</th>
              </tr>
            </thead>
            <tbody>
              {data?.itens?.length &&
                data?.itens.map((item) => (
                  <tr key={item.id} className="orcamento-print-fs-07">
                    <td>{item.codigo}</td>
                    <td>{item.descricao}</td>
                    <td className="text-end">{item.unidade}</td>
                    <td className="text-center">{item.quantidade}</td>
                    <td className="text-end">
                      {typeof item.valorUnitario == "number"
                        ? item.valorUnitario.toFixed(2)
                        : 0}
                    </td>
                    <td className="text-end">
                      {typeof item.totalItem == "number"
                        ? item.totalItem.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Grid>

        <div className="totals-container">
          <div className="total-row">
            <strong>VALOR TOTAL DOS PRODUTOS:</strong>
            <span>{formatPrice(data?.totalItens || 0, false)}</span>
          </div>
          <div className="total-row">
            <strong>DESCONTO:</strong>
            <span>{formatPrice(data?.desconto || 0, false)}</span>
          </div>
          <div className="total-row">
            <strong>ACRÉSCIMO:</strong>
            <span>{formatPrice(data?.acrescimo || 0, false)}</span>
          </div>
          <div className="total-row">
            <strong>DESPESAS:</strong>
            <span>{formatPrice(data?.despesas || 0, false)}</span>
          </div>
          <div className="total-row grand-total">
            <strong>TOTAL DA NOTA:</strong>
            <span>{formatPrice(data?.totalPedido || 0, false)}</span>
          </div>
        </div>

        <Grid item md={12} xs={12} className="mt-4 orcamento-print-fs-07">
          <table className="table">
            <thead style={{ background: "#E7E5E6" }}>
              <tr>
                <th className="p-0">
                  <b>DADOS DE PAGAMENTO</b>
                </th>
              </tr>
            </thead>
          </table>
        </Grid>

        <Grid
          item
          md={12}
          xs={12}
          className="mt-2 d-flex justify-content-between orcamento-print-fs-07"
        >
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Nº TÍTULO:</th>
                <th scope="col">VENCIMENTO:</th>
                <th scope="col">VALOR:</th>
                <th scope="col">MEIO DE PAGAMENTO:</th>
              </tr>
            </thead>
            <tbody>
              {data.pagamentos &&
                data.pagamentos.length > 0 &&
                data.pagamentos.map((parcela) => (
                  <tr key={parcela.id}>
                    <td>{parcela.numeroTitulo}</td>
                    <td>
                      {new Date(
                        Date.parse(parcela.vencimento)
                      ).toLocaleDateString("pt-BR")}
                    </td>
                    <td>
                      {parcela.valorTitulo
                        ? formatPrice(parcela.valorTitulo)
                        : "R$ 0,00"}
                    </td>
                    <td>
                      {
                        value.autoComplete(
                          data.meioPagamentoList,
                          parcela.meioPagamentoId
                        )?.descricao
                      }
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Grid>

        <Grid item md={12} xs={12} className="mt-4 orcamento-print-fs-07">
          <table className="table">
            <thead style={{ background: "#E7E5E6" }}>
              <tr>
                <th className="p-0">OBSERVAÇÕES</th>
              </tr>
            </thead>
          </table>
        </Grid>
        <div style={{ width: "100%" }}>
          <span className="fs-6 fw-normal">{data.informacaoAdicional}</span>
        </div>
        <div
          style={{
            marginTop: "5rem",
            width: "100%",
            textAlign: "center",
            padding: "3rem",
          }}
        >
          <div style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}>
            <hr
              style={{ borderTop: "1px solid #666", width: "100%", margin: 0 }}
            />
            <span className="orcamento-print-fs-07 fw-normal text-center">
              Assinatura do Cliente
            </span>
            <div className="mt-5 d-flex justify-content-end">
              <span className="orcamento-print-fs-07 fw-light">
                Pedido emitido no SIAF Evolution – www.siafevolution.com.br
              </span>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default MainPrintLayout;
